import { FC } from 'react';
import ComplianceReminder from './ComplianceReminder';
import SelfDisclosure from './SelfDisclosure';

const DisclosureFooter: FC = () => {
    return (
        <>
            <SelfDisclosure />
            <ComplianceReminder />
        </>
    );
};

export default DisclosureFooter;
